var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72.196,
    height: 70.616,
    viewBox: "0 0 72.196 70.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.076,
    y1: 0.064,
    x2: 0.886,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e142c0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 72.196,
    height: 70.616,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M-961.376-1272c-3.362-2.289-5.124-5.268-5.124-8.331v-26.5c0-3.067,1.775-6.031,5.137-8.333,4-2.73,10.429-4.582,17.711-4.582s13.714,1.852,17.714,4.582c3.362,2.3,5.135,5.266,5.135,8.333v26.5c0,3.064-1.76,6.043-5.124,8.331-4.011,2.729-10.441,4.593-17.726,4.593S-957.365-1269.274-961.376-1272Zm.828-8.331c0,1.332,1.074,2.406,2.536,3.4,3.232,2.213,8.474,3.557,14.36,3.557s11.127-1.344,14.363-3.557c1.461-1,2.534-2.07,2.534-3.4v-4.415c-4.039,2.448-10.08,4.092-16.9,4.092s-12.86-1.644-16.9-4.092Zm0-13.248c0,1.331,1.074,2.4,2.536,3.4,3.232,2.213,8.474,3.557,14.36,3.557s11.127-1.344,14.363-3.557c1.461-1,2.534-2.07,2.534-3.4V-1298c-4.032,2.449-10.075,4.095-16.9,4.095s-12.871-1.648-16.9-4.1Zm2.536-16.653c-1.462,1-2.536,2.069-2.536,3.4s1.074,2.4,2.536,3.4c3.232,2.211,8.474,3.558,14.36,3.558s11.127-1.346,14.363-3.558c1.461-1,2.534-2.071,2.534-3.4s-1.074-2.407-2.534-3.4c-3.236-2.2-8.475-3.546-14.363-3.546S-954.779-1312.435-958.011-1310.234Zm-15.682,24.387c-6.33-.531-11.711-2.472-15.037-5.071-2.805-2.2-4.27-4.9-4.27-7.7v-26.5c0-3.067,1.777-6.029,5.139-8.333,4-2.729,10.429-4.577,17.711-4.577s13.714,1.849,17.714,4.577c3.362,2.3,5.135,5.266,5.135,8.333a2.975,2.975,0,0,1-2.975,2.974,2.976,2.976,0,0,1-2.976-2.974c0-1.332-1.072-2.407-2.534-3.4-3.236-2.2-8.474-3.56-14.363-3.56s-11.129,1.361-14.36,3.56c-1.464.995-2.536,2.07-2.536,3.4,0,1.14.828,2.1,1.981,2.986,2.6,2.047,6.868,3.419,11.824,3.843a2.971,2.971,0,0,1,2.718,3.222,2.982,2.982,0,0,1-3.223,2.716,31.314,31.314,0,0,1-13.3-3.937v4.417c0,1.3,1.036,2.368,2.447,3.339a21.24,21.24,0,0,0,8.29,3.091,2.977,2.977,0,0,1,2.421,3.455,3,3,0,0,1-3.454,2.421,28.4,28.4,0,0,1-9.7-3.481v4.424c0,1.139.841,2.11,1.981,3,2.612,2.043,6.895,3.417,11.864,3.83a2.97,2.97,0,0,1,2.716,3.222,2.966,2.966,0,0,1-2.95,2.727Q-973.563-1285.836-973.693-1285.847Z",
    transform: "translate(992.998 1338.025)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonationIcon);
export default __webpack_public_path__ + "static/media/donation_icon.1c5709637d123d61a6546691b08f9c9d.svg";
export { ForwardRef as ReactComponent };